import styled from 'styled-components';

const Wrapper = styled.div`
  color: #35447d;
  font-size: 1.5rem;

  .content {
    padding: 7rem 16rem;
    display: flex;
    justify-content: space-between;
    .pane {
      width: 100%;
      .subTitle {
        margin-top: 1.2rem;
        margin-bottom: 3.2rem;
        font-size: 1.4rem;
        span {
          font-weight: bold;
        }
      }
      .detail {
        font-size: 1.6rem;
        margin-bottom: 4rem;
      }
      h2 {
        font-size: 2.8rem;
        font-weight: normal;
        margin: 2rem 0 2.7rem 0;
      }
      h3 {
        font-size: 2rem;
        font-weight: 700;
        margin: 2.5rem 0 1rem 0;
      }
      .toc {
        display: flex;
        flex-direction: column;
        background-color: #f8f7f3;
        box-sizing: border-box;
        padding: 2.5rem;
        width: 40rem;

        a:not(:first-of-type) {
          margin-top: 1rem;
        }
      }
      .spacer { margin-top: 5rem; }
    }
  }
  .list {
    font-size: 1.5rem;
    margin: 0;
    padding: 0;

    li {
      &:not(:first-of-type) {
        margin-top: 2rem;
      }
      a {
        color: #35447d;
        text-decoration: underline;
      }
    }
  }
  .list--indent {
    padding-left: 1.5rem
  }
  @media only screen and (max-width: 768px) {
    .toc { width: 100%; }
  }
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/containers/PrivacyPage/Wrapper.js